













































































































import { Component } from 'vue-property-decorator';
import { PaymentReceiptResponse } from '@/models/payment/payment.response';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import {paymentService} from '@/shared';

@Component({
    computed: {},
})
export default class DepositLogPaymentResponsePage extends Base {
    public loading: boolean = false;

    public txDetailId: any = '';
    public txHeaderId: any = '';
    public paymentResponse: PaymentReceiptResponse = {};
    public mounted() {
        this.txHeaderId = this.$route.query.txHeaderId;
        this.txDetailId = this.$route.query.txDetailId;
        if (this.txHeaderId && this.txDetailId) {
            this.getPaymentStatus(this.txHeaderId, this.txDetailId);
        } else { this.showAlert(false, this.$t('depositLogPaymentResponse.alertTransactionIdEmpty')); }
    }

    public async getPaymentStatus(
        txHeaderId: string,
        txDetailId: string,
    ): Promise<void> {
        try {
            this.loading = true;
            const paymentRes = await paymentService.depositLogGetResponse(
                txHeaderId,
                txDetailId,
            );
            this.paymentResponse = paymentRes;
            if (
    this.paymentResponse.paymentDetail.status === 'Approved' ||
    this.paymentResponse.paymentDetail.status === 'PartialApproved'
  ) {
    // tslint:disable-next-line:max-line-length
    this.showAlert(true, this.$t('roPaymentResponse.alertPaymentSuccess'));
  } else {
    if (this.paymentResponse.paymentDetail.status != 'Pending') {
      this.showAlert(true, paymentRes.paymentDetail.status);
    }
  }
        } finally {
            this.loading = false;
        }
    }
}
